import { useId } from "react";
import {
  AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, ReferenceLine,
} from "recharts";

// Points come from received quotes. Time passing alone never invents a price.
export function LiveChart({ seed = [], up = true, height = 260, samples = 60 }) {
  const gradient = useId();
  const data = seed.filter((p) => Number.isFinite(p) && p > 0).slice(-samples).map((p, t) => ({ p, t }));

  const color = up ? "#00E676" : "#FF3B30";
  const prices = data.map((d) => d.p);
  const min = prices.length ? Math.min(...prices) : 0;
  const max = prices.length ? Math.max(...prices) : 1;
  const pad = (max - min) * 0.15 || max * 0.01;
  const first = prices[0];

  const fmt = (v) =>
    v >= 1000 ? v.toLocaleString("en-US", { maximumFractionDigits: 2 }) : v >= 1 ? v.toFixed(2) : v.toFixed(6);

  return (
    <ResponsiveContainer width="100%" height={height}>
      <AreaChart data={data} margin={{ top: 8, right: 8, bottom: 0, left: 0 }}>
        <defs>
          <linearGradient id={gradient} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={color} stopOpacity={0.35} />
            <stop offset="100%" stopColor={color} stopOpacity={0} />
          </linearGradient>
        </defs>
        <XAxis dataKey="t" hide />
        <YAxis
          domain={[min - pad, max + pad]}
          orientation="right"
          width={64}
          tick={{ fill: "#64748B", fontSize: 10, fontFamily: "JetBrains Mono" }}
          tickFormatter={fmt}
          axisLine={false}
          tickLine={false}
        />
        {first != null && (
          <ReferenceLine y={first} stroke="#334155" strokeDasharray="4 4" />
        )}
        <Tooltip
          contentStyle={{
            background: "#121721",
            border: "1px solid #1E293B",
            borderRadius: 10,
            fontFamily: "JetBrains Mono",
            fontSize: 12,
            color: "#F8FAFC",
          }}
          labelFormatter={() => ""}
          formatter={(v) => [`$${fmt(v)}`, "Price"]}
        />
        <Area
          type="monotone"
          dataKey="p"
          stroke={color}
          strokeWidth={2}
          fill={`url(#${gradient})`}
          isAnimationActive={true}
          animationDuration={350}
          dot={false}
          activeDot={{ r: 4, fill: color, stroke: "#0B0E14", strokeWidth: 2 }}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}
